import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { MdModeEdit } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import AppDropdown from "../../../components/AppDropdown/AppDropdown";
import * as apicall from "../../../components/Apicall";
import Loader from "../../../components/Loader/Loader";
import SlidePanel from "../../../components/SlidePanel/SlidePanel";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { ImagePicker } from "../../BrandingOffers/shared";
import { STORAGE_PREFIX } from "../../../services/brandingService";

const normalize = (val) =>
  String(val || "").toLowerCase().replace(/\s+/g, "").trim();

const thStyle = {
  background: "#F9FAFB",
  fontWeight: 600,
  fontSize: "13px",
  color: "#374151",
  padding: "12px 16px",
  borderBottom: "1px solid #E5E7EB",
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: "12px 16px",
  fontSize: "14px",
  color: "#374151",
  borderBottom: "1px solid #F3F4F6",
  verticalAlign: "middle",
};

const inputStyle = {
  height: "38px",
  fontSize: "13px",
  borderRadius: "8px",
  border: "1px solid #D1D5DB",
  background: "#fff",
  color: "#374151",
  padding: "0 10px",
  outline: "none",
  width: "100%",
};


function SubcategoryRow({ item, index, parentName, onUpdate, onToggle }) {
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState(item.name);
  const [saving, setSaving] = useState(false);

  const handleEdit = async () => {
    try {
      setSaving(true);
      await apicall.post({ id: item.id, name }, "edit_service_type");
      setEditMode(false);
      onUpdate(item.id, name);
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <tr
      onMouseEnter={(e) => (e.currentTarget.style.background = "#F9FAFB")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      style={{ transition: "background 0.15s" }}
    >
      <td style={tdStyle}>{index + 1}</td>
      <td style={{ ...tdStyle, padding: "0 16px" }}>
        <div style={{ display: "flex", alignItems: "center", height: "56px" }}>
          {editMode ? (
            <div className="d-flex align-items-center gap-2" style={{ width: "100%" }}>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleEdit()}
                className="form-control"
                style={{ maxWidth: "220px" }}
                autoFocus
              />
              {saving ? (
                <Loader style={{ width: 30, height: 16 }} />
              ) : (
                <FaArrowRight
                  onClick={handleEdit}
                  style={{ cursor: "pointer", color: "#C0335A" }}
                />
              )}
            </div>
          ) : (
            item.name
          )}
        </div>
      </td>
      <td style={tdStyle}>{parentName}</td>
      <td style={{ ...tdStyle, cursor: "pointer", color: "#C0335A" }}>
        <MdModeEdit size={17} onClick={() => setEditMode(!editMode)} />
      </td>
      <td style={tdStyle}>
        <Form.Check
          type="switch"
          checked={item.is_active === 1}
          onChange={() => onToggle(item)}
          id={`subcat-switch-${item.id}`}
        />
      </td>
    </tr>
  );
}

function SubcategoriesTab({ label = "Sub Category", serviceLabel = "Service", onSubcategoryAdded }) {
  const [subcategories, setSubcategories] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const [allServiceOptions, setAllServiceOptions] = useState([]); // {id, name} for MultiSelect
  const [loading, setLoading] = useState(false);

  // Filter state
  const [filterServices, setFilterServices] = useState([]); // array of {id, name}
  const [activeFilter, setActiveFilter] = useState("all"); // "all" | "active" | "inactive"
  const [search, setSearch] = useState("");
const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  // Add panel state
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [addName, setAddName] = useState("");
  const [addServiceObj, setAddServiceObj] = useState(null); // {id, name}
  const [addIcon, setAddIcon] = useState(null); // base64 data URL of the icon picked for the new sub category
  const [addError, setAddError] = useState("");
  const [adding, setAdding] = useState(false);

  const [showDeletePanel, setShowDeletePanel] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [showInactivePanel, setShowInactivePanel] = useState(false);
  const [pendingToggle, setPendingToggle] = useState(null);
  const [confirmingInactive, setConfirmingInactive] = useState(false);

  useEffect(() => {
    fetchAll();
  }, []);

  useEffect(() => {
    fetchSubcategories();
  }, [filterServices]); // eslint-disable-line react-hooks/exhaustive-deps


  async function fetchAll() {
    try {
      setLoading(true);
      // allSettled ensures services load even if the types request fails
      const [typesResult, servicesResult] = await Promise.allSettled([
        apicall.get("get_ezp_service_types"),
        apicall.get("get_ezp_service"),
      ]);
      if (typesResult.status === "fulfilled" && typesResult.value?.success) {
        setSubcategories(typesResult.value.data || []);
      }
      if (servicesResult.status === "fulfilled" && servicesResult.value?.success) {
        const svc = servicesResult.value.data || [];
        setAllServices(svc);
        setAllServiceOptions(svc.map((s) => ({ id: s.id, name: s.name })));
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  async function fetchSubcategories() {
    try {
      const ids = filterServices.map((s) => s.id);
      const query =
        ids.length > 0
          ? `get_ezp_service_types?services=${ids.join(",")}`
          : "get_ezp_service_types";
      const res = await apicall.get(query);
      if (res.success) setSubcategories(res.data || []);
    } catch (e) {
      console.error(e);
    }
  }

  async function handleAdd() {
    if (!addName.trim()) { setAddError("Name is required"); return; }
    if (!addServiceObj) { setAddError(`Parent ${serviceLabel.toLowerCase()} is required`); return; }

    // Check backend for existing sub categories under this service before inserting
    try {
      const checkRes = await apicall.get(
        `get_ezp_service_types?services=${addServiceObj.id}`
      );
      const existing = checkRes?.data || [];
      const duplicate = existing.some(
        (s) => normalize(s.name) === normalize(addName)
      );
      if (duplicate) {
        setAddError(
          `This ${label.toLowerCase()} already exists under "${addServiceObj.name}"`
        );
        return;
      }
    } catch (e) {
      // if the check fails, proceed and let the backend handle it
    }

    try {
      setAdding(true);
      const res = await apicall.post(
        { name: addName, service_id: Number(addServiceObj.id), icon: addIcon || undefined, storage_prefix: STORAGE_PREFIX },
        "add_service_type"
      );
      if (res?.success) {
        toast.success(res.message || "Sub category added successfully");
        resetAddPanel();
        fetchSubcategories();
        if (onSubcategoryAdded) {
          onSubcategoryAdded({
            id: addServiceObj.id,
            name: addServiceObj.name,
            newSubCategoryName: addName.trim(),
          });
        }
      } else {
        setAddError(res?.message || "Failed to add. Please try again.");
      }
    } catch (e) {
      setAddError("Failed to add. Please try again.");
      console.error(e);
    } finally {
      setAdding(false);
    }
  }

  const handleDelete = async () => {
    try {
      setDeleting(true);
      const res = await apicall.post({ id: selectedItem.id }, "delete_service_type");
      if (res?.success) {
        toast.success(res.message);
        fetchAll();
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setDeleting(false);
      setShowDeletePanel(false);
      setSelectedItem(null);
    }
  };

  const handleToggle = async (item) => {
    const newStatus = item.is_active === 1 ? 0 : 1;

    if (newStatus === 0) {
      try {
        const checkRes = await apicall.post(
          { id: item.id, type: "service_type" },
          "check_active_status"
        );
        if (checkRes.hasBookings) {
          setPendingToggle({ item, count: checkRes.count });
          setShowInactivePanel(true);
          return;
        }
      } catch (e) {
        console.error(e);
      }
    }

    try {
      await apicall.post(
        { id: item.id, is_active: newStatus, type: "service_type" },
        "active_status"
      );
      setSubcategories((prev) =>
        prev.map((s) => (s.id === item.id ? { ...s, is_active: newStatus } : s))
      );
    } catch (e) {
      console.error(e);
    }
  };

  const confirmInactive = async () => {
    if (!pendingToggle) return;
    try {
      setConfirmingInactive(true);
      await apicall.post(
        { id: pendingToggle.item.id, is_active: 0, type: "service_type" },
        "active_status"
      );
      setSubcategories((prev) =>
        prev.map((s) =>
          s.id === pendingToggle.item.id ? { ...s, is_active: 0 } : s
        )
      );
    } catch (e) {
      console.error(e);
    } finally {
      setConfirmingInactive(false);
      setShowInactivePanel(false);
      setPendingToggle(null);
    }
  };

  const openAddPanel = () => {
    setAddServiceObj(filterServices.length === 1 ? filterServices[0] : null);
    setAddName("");
    setAddIcon(null);
    setAddError("");
    setShowAddPanel(true);
  };

  const resetAddPanel = () => {
    setShowAddPanel(false);
    setAddError("");
    setAddName("");
    setAddIcon(null);
    setAddServiceObj(null);
  };

  const getParentName = (serviceId) =>
    allServices.find((s) => Number(s.id) === Number(serviceId))?.name || "-";


  // Apply frontend filters: name search + active/inactive
  // const filtered = subcategories.filter((s) => {
  //   const matchesSearch = s.name?.toLowerCase().includes(search.toLowerCase());
  //   const matchesActive =
  //     activeFilter === "all"
  //       ? true
  //       : activeFilter === "active"
  //       ? s.is_active === 1
  //       : s.is_active === 0;
  //   return matchesSearch && matchesActive;
  // });
const filtered = subcategories.filter((s) => {
  const matchesSearch = s.name
    ?.toLowerCase()
    .includes(search.toLowerCase());

  const matchesSubCategory =
    selectedSubCategories.length === 0 ||
    selectedSubCategories.some(
      (item) => Number(item.id) === Number(s.id)
    );

  const matchesActive =
    activeFilter === "all"
      ? true
      : activeFilter === "active"
      ? Number(s.is_active) === 1
      : Number(s.is_active) === 0;

  return (
    matchesSearch &&
    matchesSubCategory &&
    matchesActive
  );
});
  return (
    <div>
      {/* Row 1: Title + action */}
      <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
        <div>
          <h5 className="mb-1 fw-bold" style={{ color: "#111827" }}>
            {label}
          </h5>
          <p className="mb-0" style={{ fontSize: "13px", color: "#6B7280" }}>
            Manage {label.toLowerCase()} entries grouped under{" "}
            {serviceLabel.toLowerCase()} categories.
          </p>
        </div>
        <button
          onClick={openAddPanel}
          className="btn btn-danger"
          style={{
            borderRadius: "8px",
            fontSize: "13px",
            fontWeight: 600,
            height: "38px",
            whiteSpace: "nowrap",
          }}
        >
          + Add {label}
        </button>
      </div>

      {/* Row 2: Filters */}
      <div className="d-flex gap-2 mb-3 flex-wrap align-items-center">
        {/* Service MultiSelect — matches ServiceTypesTab style */}
        <div style={{ flex: "1 1 200px", minWidth: "160px" }}>
          <MultiSelect
            value={filterServices}
            onChange={(e) => setFilterServices(e.value || [])}
            options={allServiceOptions}
            optionLabel="name"
            filter
            showClear
            filterDelay={300}
            placeholder={`All ${serviceLabel}s`}
            maxSelectedLabels={2}
            style={{ width: "100%", height: "38px" }}
          />
        </div>

        {/* Search */}
        <div
          style={{
            flex: "1 1 200px",
            minWidth: "140px",
            position: "relative",
          }}
        >
          <IoSearchOutline
            size={15}
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#9CA3AF",
              pointerEvents: "none",
            }}
          />
          <MultiSelect
  value={selectedSubCategories}
  onChange={(e) => setSelectedSubCategories(e.value || [])}
  options={subcategories.map((s) => ({
    id: s.id,
    name: s.name,
  }))}
  optionLabel="name"
  filter
  showClear
  filterDelay={300}
  placeholder={`Search ${label}s`}
  maxSelectedLabels={2}
  style={{ width: "100%", height: "38px" }}
/>
          {/* <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={`Search ${label.toLowerCase()}...`}
            style={{ ...inputStyle, paddingLeft: "32px" }}
          /> */}
        </div>

        {/* Status filter dropdown */}
        <AppDropdown
          value={activeFilter}
          options={[
            { label: "All", value: "all" },
            { label: "Active", value: "active" },
            { label: "Inactive", value: "inactive" },
          ]}
          onChange={e => setActiveFilter(e.value)}
          style={{ width: "140px", height: "38px", fontSize: "13px", flexShrink: 0 }}
        />

        {/* Clear All */}
        {(filterServices.length > 0 || activeFilter !== "all" || search.trim()) && (
          <button
            style={{
              background: "none",
              border: "none",
              color: "#C0335A",
              fontSize: "13px",
              fontWeight: 500,
              cursor: "pointer",
              padding: "0 4px",
              flexShrink: 0,
            }}
           onClick={() => {
  setFilterServices([]);
  setSelectedSubCategories([]);
  setActiveFilter("all");
  setSearch("");
}}
          >
            Clear All
          </button>
        )}
      </div>

      {/* Table */}
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}
      >
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["Sl. No", "Name", `Parent ${serviceLabel}`, "Edit", "Active"].map(
                  (h) => (
                    <th key={h} style={thStyle}>
                      {h}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(6)
                  .fill(null)
                  .map((_, i) => (
                    <tr key={i}>
                      <td style={tdStyle}>
                        <Skeleton width="30px" />
                      </td>
                      <td style={tdStyle}>
                        <Skeleton width="160px" />
                      </td>
                      <td style={tdStyle}>
                        <Skeleton width="120px" />
                      </td>
                      <td style={tdStyle}>
                        <Skeleton width="24px" />
                      </td>
                      <td style={tdStyle}>
                        <Skeleton width="50px" />
                      </td>
                    </tr>
                  ))
              ) : filtered.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                      color: "#6B7280",
                      padding: "48px",
                    }}
                  >
                    {search
                      ? `No results for "${search}"`
                      : `No ${label.toLowerCase()} entries found`}
                  </td>
                </tr>
              ) : (
                filtered.map((item, idx) => (
                  <SubcategoryRow
                    key={item.id}
                    item={item}
                    index={idx}
                    parentName={getParentName(item.service)}
                    onUpdate={(id, newName) =>
                      setSubcategories((prev) =>
                        prev.map((s) =>
                          Number(s.id) === Number(id)
                            ? { ...s, name: newName }
                            : s
                        )
                      )
                    }
                    onToggle={handleToggle}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add SlidePanel */}
      <SlidePanel
        show={showAddPanel}
        onHide={resetAddPanel}
        title={`Add ${label}`}
        footer={
          <>
            <button
              className="btn btn-outline-secondary px-4"
              onClick={resetAddPanel}
            >
              Cancel
            </button>
            <button
              className="btn Button primaryBackground text-white px-4"
              onClick={handleAdd}
              disabled={adding}
            >
              {adding ? <Loader style={{ width: 40, height: 20 }} /> : "Submit"}
            </button>
          </>
        }
      >
        <div className="mb-3">
          <label
            className="form-label"
            style={{ fontSize: "13px", fontWeight: 500 }}
          >
            {serviceLabel}
          </label>
          <Dropdown
            value={addServiceObj}
            onChange={(e) => {
              setAddServiceObj(e.value);
              setAddError("");
            }}
            options={allServiceOptions}
            optionLabel="name"
            placeholder={`Select ${serviceLabel}`}
            className="w-100"
            style={{ width: "100%", height: "40px", backgroundColor: "white", border: addError.includes(serviceLabel.toLowerCase()) ? "1px solid #dc3545" : "1px solid #E9ECEF" }}
            appendTo="self"
            scrollHeight="200px"
          />
          {addError && addError.includes(serviceLabel.toLowerCase()) && (
            <small className="text-danger">{addError}</small>
          )}
        </div>
        <div className="mb-3">
          <label
            className="form-label"
            style={{ fontSize: "13px", fontWeight: 500 }}
          >
            Name
          </label>
          <input
            type="text"
            className="form-control"
            value={addName}
            onChange={(e) => {
              setAddName(e.target.value);
              setAddError("");
            }}
            placeholder={`Enter ${label.toLowerCase()} name`}
            onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          />
          {addError && !addError.includes(serviceLabel.toLowerCase()) && (
            <small className="text-danger">{addError}</small>
          )}
        </div>

        <div className="mb-3">
          <ImagePicker value={addIcon} onChange={setAddIcon} />
        </div>
      </SlidePanel>

      {/* Delete SlidePanel */}
      <SlidePanel
        show={showDeletePanel}
        onHide={() => {
          setShowDeletePanel(false);
          setSelectedItem(null);
        }}
        title={`Delete ${label}`}
      >
        <p style={{ fontSize: "15px", color: "#374151" }}>
          You are about to delete the {label.toLowerCase()}{" "}
          <strong>{selectedItem?.name}</strong>. This action cannot be undone.
          Are you sure you want to proceed?
        </p>
        <div className="d-flex gap-3 mt-4">
          <button
            onClick={() => {
              setShowDeletePanel(false);
              setSelectedItem(null);
            }}
            className="btn btn-outline-secondary px-4"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="btn Button primaryBackground text-white px-4"
            disabled={deleting}
          >
            {deleting ? <Loader style={{ width: 40, height: 20 }} /> : "Delete"}
          </button>
        </div>
      </SlidePanel>

      {/* Inactive Confirmation SlidePanel */}
      <SlidePanel
        show={showInactivePanel}
        onHide={() => {
          setShowInactivePanel(false);
          setPendingToggle(null);
        }}
        title={`Inactive ${label}`}
      >
        <p style={{ fontSize: "15px", color: "#374151" }}>
          There are <strong>{pendingToggle?.count}</strong> booking record(s) found
          for <strong>{pendingToggle?.item?.name}</strong>. If you inactive this{" "}
          {label.toLowerCase()}, those bookings will not be editable.
        </p>
        <div className="d-flex gap-3 mt-4">
          <button
            onClick={() => {
              setShowInactivePanel(false);
              setPendingToggle(null);
            }}
            className="btn btn-outline-secondary px-4"
          >
            Cancel
          </button>
          <button
            onClick={confirmInactive}
            className="btn Button primaryBackground text-white px-4"
            disabled={confirmingInactive}
          >
            {confirmingInactive ? (
              <Loader style={{ width: 40, height: 20 }} />
            ) : (
              "Inactive"
            )}
          </button>
        </div>
      </SlidePanel>
    </div>
  );
}

export default SubcategoriesTab;
